import React from "react"

//components
import { IconLibrary, ThriveIcon } from "../..";

//interfacess
import { IAppHeader } from "../../../interfaces/mobileAppPreview/mobileAppPreview";



const AppHeader = ({appName}:IAppHeader) => {

    return (
        <div className="app-header">
            <ThriveIcon 
                iconName={IconLibrary.MENU} 
                sizeInPx="14"
            />

            <h1 className="app-banner-title">{appName || "Your App Name"}</h1>


            <div className="right-panel">
                <ThriveIcon 
                    iconName={IconLibrary.SEARCH_GLASS} 
                    sizeInPx="14"
                />

                <ThriveIcon 
                    iconName={IconLibrary.BELL} 
                    sizeInPx="14"
                />
            </div>
        </div>
    )
}

export default AppHeader